import InterswitchService from "../services/billing_services/interswitchEndpoints/interswitch.service";
import { setInterswitchBillers, setInterswitchErrorMessage } from "../store/interswitchData.store";

export default async function fetchAndSetInterswitchBillers() {
    return await InterswitchService.getInterswitchBillers()
      .then((res) => {
        setInterswitchBillers(res?.BillerList.Category);
        setInterswitchErrorMessage(
         null
        );
      })
      .catch(() => {
        setInterswitchErrorMessage(
          "Cannot access Interswitch servers at the moment. Try again later."
        );
      });
  }
